module.exports = __webpack_public_path__ + "img/outcome_target.d6a0a068.svg";